module.exports = __webpack_public_path__ + "8b3e90ef87efcde8d69a90e8ba083c92.png";